
// Function to add attribute to all iframes
function addAttributeToIframes() {
  const iframes = document.querySelectorAll('iframe');

  iframes.forEach(iframe => {
    iframe.setAttribute('data-hj-allow-iframe', '');
  });
}

// Wait for all resources to load, including iframes
window.addEventListener('load', addAttributeToIframes);

// Function to add attribute to an iframe
function addAttributeToIframe(iframe) {
    iframe.setAttribute('data-hj-allow-iframe', '');
  }
  
  // Function to handle mutations (new elements added)
  function handleMutations(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const addedNodes = mutation.addedNodes;
        addedNodes.forEach(node => {
          if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
            addAttributeToIframe(node);
          }
        });
      }
    }
  }
  
  // Wait for all resources to load, including iframes
  window.addEventListener('load', () => {
    // Add attribute to existing iframes
    const existingIframes = document.querySelectorAll('iframe');
    existingIframes.forEach(iframe => {
      addAttributeToIframe(iframe);
    });
  
    // Set up MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(handleMutations);
    const observerConfig = { childList: true, subtree: true };
    observer.observe(document.body, observerConfig);
  });